import React from 'react'
import CloseIcon from '../../SVGS/CloseIcon'

const PopupHeader = ({ uniqueId, onClose, heading = "Template Popup", className, description }) => {
    return (
        <div id={uniqueId} className={`pt-10 pb-3 mb-5 text-2xl font-semibold border-b cursor-grab ${className}`} >
            <div className="flex justify-between items-start">
                <span>{heading}</span>
                {!!onClose && (
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-500 flex-shrink-0 ml-2"
                    >
                        <CloseIcon className="h-6 w-6" />
                    </button>
                )}
            </div>
            {!!description && (
                <p className="text-sm text-gray-600 mt-1 font-normal">
                    {description}
                </p>
            )}
        </div>
    )
}

export default PopupHeader